module.exports = __webpack_public_path__ + "static/media/ProfilePic250px.f63bc905.jpeg";